import { createApi } from '@reduxjs/toolkit/query/react';
import { baseUsersBFFQuery } from './config';
import { EntitlementResponse } from 'src/types/bff/models/EntitlementResponse';

export enum BFFTags {
  Entitlements = 'Entitlements',
}

export const bffApi = createApi({
  reducerPath: 'bffApi',
  tagTypes: [BFFTags.Entitlements],
  baseQuery: baseUsersBFFQuery,
  endpoints: (build) => ({
    getEntitlements: build.query<EntitlementResponse, { user_id: string }>({
      query: ({ user_id }) => ({
        url: `users/${user_id}/entitlements`,
      }),
      providesTags: [BFFTags.Entitlements],
    }),
  }),
});

export const { useGetEntitlementsQuery } = bffApi;
